export default __webpack_public_path__ + "static/media/people6.db1fbcd3.jpeg";